// extracted by mini-css-extract-plugin
export default {"container":"specialCalcLink_container__e+HA0","gradAnim":"specialCalcLink_gradAnim__1OKSu","inner":"specialCalcLink_inner__P0vwk","link":"specialCalcLink_link__KYpxO"};